<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialog" max-width="800">
      <v-card>
        <v-card-title class="headline">LEAD VIEW</v-card-title>
        <v-card-text>
          <v-layout row wrap>
            
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="success" flat="flat" @click.native="closeD()">copy key</v-btn>
          <v-btn color="error" flat="flat" @click.native="closeD()">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import { firebase, db, auth, createFirebase, store } from '@/fb';
import { getRandomInt, randomString, getCDate} from '@/customFunction';
import axios from 'axios';

export default {
  data(){
    return {
      getKey:null
    }
  },
  methods: {
    clipboardSuccessHandler ({ value, event }){
      this.$emit('snackbarNotification', `Copied`, 'success')
    },
    clipboardErrorHandler ({ value, event }) {
      this.$emit('snackbarNotification', `Failed`, 'error')
    },
    openD(){
      this.$store.commit('openDialog')
    },
    closeD(){
      this.$store.commit('closeDialog')
    }
  },
  
  computed:{
    dialog(){
      this.getKey = this.$store.state.leadViewKey
      console.log(this.getKey)
      return this.$store.state.leadViewShow
    },
  },
  async created(){
    // this.openD()
  },
  mounted (){
  }
}
</script>


<style>

</style>